import { render, staticRenderFns } from "./SystemBuilderComponent.vue?vue&type=template&id=9a649ab6&"
import script from "./SystemBuilderComponent.vue?vue&type=script&lang=js&"
export * from "./SystemBuilderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports